import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <section className="bg-white border-b border-slate-200 py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-[#0f1f2e] mb-4">Terms of Service</h1>
          <p className="text-slate-500">Last updated: January 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <Card className="bg-white border-slate-200 shadow-sm">
            <CardContent className="p-8 md:p-12 prose prose-slate max-w-none">
              <p className="text-lg text-slate-600 leading-relaxed mb-8">
                Please read these Terms of Service carefully before using the IpFunders website. By accessing or using our website, you agree to be bound by these terms.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">No Advisory Relationship</h2>
              <p className="text-slate-600 leading-relaxed">
                Use of this website, including submitting information through any contact form or email link, does not create a client relationship or advisory engagement unless expressly confirmed in writing through a formal engagement agreement.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">Informational Purposes Only</h2>
              <p className="text-slate-600 leading-relaxed">
                Content on this website is for general informational purposes only and does not constitute legal, financial, or investment advice. Any formal engagement is subject to a written agreement and is based on specific facts and circumstances.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">Scope of Services</h2>
              <p className="text-slate-600 leading-relaxed">
                IpFunders provides IP protection funding and related services. We fund patent prosecution and related intellectual property development. Any services are subject to a written engagement agreement and evaluation criteria.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">Limitation of Liability</h2>
              <p className="text-slate-600 leading-relaxed">
                To the fullest extent permitted by law, IpFunders disclaims liability for any damages arising from use of this website or reliance on its content. Use of this website is at your own risk.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">Third-Party Links</h2>
              <p className="text-slate-600 leading-relaxed">
                This website may contain links to third-party websites. IpFunders does not control or endorse these sites and is not responsible for their content, privacy practices, or terms of use.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">Governing Law</h2>
              <p className="text-slate-600 leading-relaxed">
                These Terms of Service are governed by the laws of the jurisdiction where IpFunders is principally located, without regard to conflict-of-law principles.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">Intellectual Property</h2>
              <p className="text-slate-600 leading-relaxed">
                All content on this website, including text, graphics, logos, and design, is the property of IpFunders or its licensors and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without express written permission.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default TermsOfServicePage;
